import htmlToPdfmake from 'html-to-pdfmake'
import {
  sanitizeStoredHtml,
  storedHtmlToPlainTextWithBreaks
} from '../../common/utils/html'

// Derived from html-to-pdfmake's own signature so we stay compatible with the exact
// pdfmake types it ships, avoiding clashes with a second copy of @types/pdfmake.
export type PdfmakeContent = ReturnType<typeof htmlToPdfmake>
type RichTextStyles = NonNullable<
  Parameters<typeof htmlToPdfmake>[1]
>['defaultStyles']

/**
 * pdfmake styles applied to the tags html-to-pdfmake emits, so converted rich text
 * matches the surrounding PDF body (12pt) instead of the library's larger defaults.
 */
const richTextDefaultStyles: RichTextStyles = {
  p: { fontSize: 12, margin: [0, 0, 0, 6] },
  ul: { fontSize: 12, margin: [0, 0, 0, 6] },
  ol: { fontSize: 12, margin: [0, 0, 0, 6] },
  li: { fontSize: 12 },
  h1: { fontSize: 16, bold: true, margin: [0, 0, 0, 6] },
  h2: { fontSize: 14, bold: true, margin: [0, 0, 0, 6] },
  h3: { fontSize: 13, bold: true, margin: [0, 0, 0, 6] },
  a: { color: '#2f80ed', decoration: 'underline' },
  blockquote: { italics: true, margin: [8, 0, 0, 6] }
}

/**
 * Converts stored rich-text HTML into pdfmake content, preserving bold, italic,
 * underline, lists, headings, links and line breaks. Sanitised first (as on screen).
 * If conversion throws on unexpected markup, degrades to plain text with the author's
 * line breaks so a single bad field never fails the whole PDF.
 */
export const richHtmlToContent = (html: string): PdfmakeContent => {
  try {
    return htmlToPdfmake(sanitizeStoredHtml(html), {
      defaultStyles: richTextDefaultStyles
    })
  } catch {
    return {
      text: storedHtmlToPlainTextWithBreaks(html),
      style: 'tableHeaderSmall'
    }
  }
}
